import { useCallDurationRule } from "@/hooks/useCallDurationRule/useCallDurationRule";

import { useCall } from "@/hooks/useCall/useCall";

export function useHeaderRules() {
  const { isCallDurationLow } = useCallDurationRule();
  const { call } = useCall();

  const shouldDisplayInfoBanner =
    isCallDurationLow && call?.type !== "voicemail";

  return {
    shouldDisplayInfoBanner,
  };
}
